<template>
  <b-card>
    <b-table
      v-if="!autocallData.error"
      responsive
      hover
      :items="tableItems"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :sort-compare="sortCompare"
      @row-clicked="onRowClicked"
    />

    <div v-if="autocallData.loading">
      <loading-container />
    </div>
    <no-data-container
      v-else-if="autocallData.data.length < 1"
      message="No Autocall Products Found"
    />
  </b-card>
</template>

<script>
import {
  BCard, BTable,
} from 'bootstrap-vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import NoDataContainer from '@/views/components/NoDataContainer.vue'

export default {
  components: {
    BCard,
    BTable,
    LoadingContainer,
    NoDataContainer,
  },
  props: {
    autocallData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      fields: [
        {
          key: 'reportNumber',
          label: 'Report Number',
          sortable: true,
          thStyle: { width: '8%' },
        },
        {
          key: 'provider',
          label: 'Provider',
          sortable: true,
          thStyle: { width: '10%' },
        },
        {
          key: 'type',
          label: 'Autocall Type',
          sortable: true,
          thStyle: { width: '10%' },
        },
        {
          key: 'underlying',
          label: 'Underlying',
          sortable: true,
          thStyle: { width: '10%' },
          tdClass: 'text-nowrap-ellipsis',
        },
        {
          key: 'firstactime',
          label: 'First AC Time (years)',
          sortable: true,
          thStyle: { width: '8%' },
        },
        {
          key: 'acfrequency',
          label: 'AC Frequency',
          sortable: true,
          thStyle: { width: '8%' },
        },
        {
          key: 'firstautocalllevel',
          label: 'First ACL',
          sortable: true,
          thStyle: { width: '7%' },
        },
        {
          key: 'finalautocalllevel',
          label: 'Final ACL',
          sortable: true,
          thStyle: { width: '7%' },
        },
        {
          key: 'barrierlevel',
          label: 'Barrier',
          sortable: true,
          thStyle: { width: '7%' },
        },
        {
          key: 'ratecoupon',
          label: 'Rate/Coupon',
          sortable: true,
          thStyle: { width: '8%' },
        },
        {
          key: 'couponbarrier',
          label: 'Coupon Barrier',
          sortable: true,
          thStyle: { width: '8%' },
        },
        {
          key: 'couponhasmemory',
          label: 'Memory',
          sortable: true,
          thStyle: { width: '6%' },
        },
      ],
    }
  },
  computed: {
    tableItems() {
      // Add a sort helper property for frequency
      return this.autocallData.data.map(item => ({
        ...item,
        _acfrequencyOrder: this.getFrequencyOrder(item.acfrequency),
      }))
    },
  },
  methods: {
    getFrequencyOrder(frequency) {
      // Map frequency strings to numeric values for sorting
      // Lower numbers = longer time periods
      const frequencyMap = {
        yearly: 6,
        'half-yearly': 5,
        quarterly: 4,
        bimonthly: 3,
        monthly: 2,
        daily: 1,
      }

      // Convert to lowercase for case-insensitive matching
      const key = frequency ? frequency.toLowerCase() : ''
      return frequencyMap[key] || 999 // Unknown frequencies sort to the end
    },
    sortCompare(aRow, bRow, key) {
      // Custom sort for AC Frequency column
      if (key === 'acfrequency') {
        const aOrder = this.getFrequencyOrder(aRow[key])
        const bOrder = this.getFrequencyOrder(bRow[key])
        return aOrder - bOrder
      }
      // Default sort for other columns
      return false
    },
    onRowClicked(item) {
      // Navigate to product report
      this.$router.push({ path: `/product/report/${item.reportNumber}` })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .text-nowrap-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}
</style>
